module.exports = __webpack_public_path__ + "static/media/ever-heard-move-to-earn.70cd61e0.png";